<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d12e196">Contents</p>
<p class="cpt" id="d12e198"><a href="#/Tada_9780310297864_epub_c2a_r1" id="d12e199">Title Page</a></p>
<p class="cpt" id="d12e201"><a href="#/Tada_9780310297864_epub_c4_r1#d12e135" id="d12e202">Copyright Page</a></p>
<p class="cpt" id="d12e204"><a href="#/Tada_9780310297864_epub_c6_r1#d12e254" id="d12e205">Before you begin. . .</a></p>
<p class="cpt" id="d12e207"><a href="#/Tada_9780310297864_epub_c7_r1#d12e303" id="d12e208">January</a></p>
<p class="cpt" id="d12e210"><a href="#/Tada_9780310297864_epub_c8_r1#d12e1363" id="d12e211">February</a></p>
<p class="cpt" id="d12e213"><span href="#/Tada_9780310297864_epub_c9_r1#d12e2304" id="d12e214" title="Link target outside of Sample">March</span></p>
<p class="cpt" id="d12e216"><span href="#/Tada_9780310297864_epub_c11_r1#d12e3302" id="d12e217" title="Link target outside of Sample">April</span></p>
<p class="cpt" id="d12e219"><span href="#/Tada_9780310297864_epub_c12_r1#d12e4235" id="d12e220" title="Link target outside of Sample">May</span></p>
<p class="cpt" id="d12e222"><span href="#/Tada_9780310297864_epub_c13_r1#d12e5210" id="d12e223" title="Link target outside of Sample">June</span></p>
<p class="cpt" id="d12e225"><span href="#/Tada_9780310297864_epub_c14_r1#d12e6132" id="d12e226" title="Link target outside of Sample">July</span></p>
<p class="cpt" id="d12e229"><span href="#/Tada_9780310297864_epub_c15_r1#d12e7115" id="d12e230" title="Link target outside of Sample">August</span></p>
<p class="cpt" id="d12e232"><span href="#/Tada_9780310297864_epub_c16_r1#d12e8057" id="d12e233" title="Link target outside of Sample">September</span></p>
<p class="cpt" id="d12e235"><span href="#/Tada_9780310297864_epub_c17_r1#d12e8979" id="d12e236" title="Link target outside of Sample">October</span></p>
<p class="cpt" id="d12e238"><span href="#/Tada_9780310297864_epub_c18_r1#d12e9990" id="d12e239" title="Link target outside of Sample">November</span></p>
<p class="cpt" id="d12e241"><span href="#/Tada_9780310297864_epub_c19_r1#d12e10936" id="d12e242" title="Link target outside of Sample">December</span></p>
<p class="cpt" id="d12e244"><span href="#/Tada_9780310297864_epub_c19b_r1#d12e11891" id="d12e245" title="Link target outside of Sample">Notes</span></p>
<p class="cpt" id="d12e247"><span href="#/Tada_9780310297864_epub_c19c_r1#d12e12249" id="d12e248" title="Link target outside of Sample">About the Publisher</span></p>
<p class="cpt" id="d12e250"><span href="#/Tada_9780310297864_epub_c19d_r1#d12e12258" id="d12e2261" title="Link target outside of Sample">Share Your Thoughts</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tada_9780310297864_epub_c4a_r1.vue?9e273e60